import * as React from "react";
import StudentController from "../api/StudentController";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as studentActionCreator from "../redux/actions/student";
import * as appActionCreator from "../redux/actions/app";

interface SearchBarState
{
    options?: Student[];
    isLoading: boolean;
    minLength: number;
}

class SearchBar extends React.Component<any, SearchBarState>
{
    studentController = new StudentController();

    state =
        {
            options: undefined,
            isLoading: false,
            minLength: 3,
        };

    handleSearch = (query: string): void => 
    {
        this.setState({ isLoading: true });
        this.studentController.getStudents(query, true)
            .then(({ students }) => 
            {
                if (!students)
                    students = [];

                this.setState(
                    {
                        isLoading: false,
                        options: students
                    });
            });
    }

    onChange = async (student: Student): Promise<void> => 
    {
        if (student != null) 
        {
            const instance = this._typeahead.getInstance();
            const selectedStudent = { kerbId: student.kerbId, name: student.fullName };
            this.props.actions.selectStudent(selectedStudent);

            if (window.location.hash.split("/")[2])
            {
                let URLparts = window.location.hash.split("/");

                window.location.href = URLparts[0] + URLparts[1] + "/" + student.kerbId;
            }

            this.setState({ options: [] });
            instance.clear();
        }
    }

    render(): React.ReactNode 
    {
        return <div>
            <i className="far fa-search typeahead-icon"></i>
            {
                <AsyncTypeahead
                    {...this.state}
                    filterBy={() =>
                    {
                        return true;
                    }}
                    labelKey={"fullName"}
                    id="Search"
                    multiple={false}
                    onInputChange={() => this.setState({ options: [] })}
                    useCache={false}
                    placeholder="Search for Student Name, Kerb or MIT ID"
                    onChange={(e) => this.onChange(e[0] as Student)}
                    onSearch={this.handleSearch}
                    delay={300}
                    ref={(ref) => this._typeahead = ref}
                    renderMenuItemChildren={(option) => (
                        <b>{option.fullName}</b>
                    )}
                />
            }
        </div>;
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    actions: bindActionCreators(studentActionCreator, dispatch),
    appActions: bindActionCreators(appActionCreator, dispatch)
});

const mapStateToProps = (state: any) => ({
    role: state.app.user.role
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);